import React from 'react'
import moment from 'moment'
import { IconContext } from 'react-icons'
import { IoMdClose } from 'react-icons/io'

import { Button, Label } from 'components'

const EmailModal = ({ showEmailModal, emailTransaction, changeEmailMsg, emailMsg, loadingAskForHelp, setShowEmailModal, onAskForHelp }) => (
    <div className={`supplierTransactionsModal ${showEmailModal && 'supplierTransactionsModal--show'}`}>
        <div className="supplierTransactionsModalContents">
            <h2>Email to {emailTransaction?.address?.name || 'user'}</h2>

            <p>
                This will send an email to <strong>{emailTransaction?.address?.name || 'user'}</strong> about the order{' '}
                <strong>{emailTransaction?.title}</strong> on <strong>{moment(emailTransaction?.date).format('DD/MM/YY')}</strong>.
            </p>
            <p>Betterspace will monitor the communication and step in if our assistance is needed.</p>
            <p>This feature is for order-related purposes only.</p>
            <br />

            <Label htmlFor="emailMsg">Message</Label>
            <textarea
                className="supplierTransactionEmailInput"
                id="emailMsg"
                type="text"
                onChange={val => changeEmailMsg(val.target.value)}
                placeholder="All transaction details (e.g. name, address, title, price, date etc.) will be automatically added to this email."
                value={emailMsg}
            />

            <Button
                active={!!emailMsg && !loadingAskForHelp}
                cta
                style={{ maxWidth: '100px' }}
                loading={loadingAskForHelp}
                onClick={() => {
                    const answers = {
                        msg: emailMsg,
                        reason: 'n/a',
                        what: 'Message from Betterspace supplier about your order',
                        whatKey: 'supplier-to-user',
                    }
                    onAskForHelp(answers)
                }}
            >
                Send
            </Button>
        </div>
        <div className="supplierTransactionsModalCloseButton" onClick={() => setShowEmailModal(false)}>
            <IconContext.Provider value={{ className: 'supplierTransactionsModalCloseButtonIcon' }}>
                <IoMdClose />
            </IconContext.Provider>
        </div>
    </div>
)

export default EmailModal
